import { useQuery } from '@tanstack/react-query';

import { getRescuedAisle } from 'api/jalapeno';

import useAccountQuery from './useAccountQuery';

export const RESCUED_AISLE_QUERY_KEY = 'rescued-aisle';

const useRescuedAisleQuery = ({ queryProps } = {}) => {
    const { data: account } = useAccountQuery();
    const { chargeID } = account?.nextOrder ?? {};

    return useQuery({
        queryKey: [RESCUED_AISLE_QUERY_KEY, chargeID],
        queryFn: async () => {
            const response = await getRescuedAisle(chargeID);
            return response?.data;
        },
        enabled: !!chargeID,
        ...queryProps,
    });
};

export default useRescuedAisleQuery;
